import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';

import { clearFilter, sortPartnerOnOrder } from '../../../services/filter/actions';

import DirectoryPage from './DirectoryPage';
import { HeadComponent } from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

export class MostPopularDirectoryPage extends React.Component {
    componentDidMount() {
        this.props.clearFilter();
    }

    render() {
        const { match, isCodePromo = false, i18nPage } = this.props;
        const isOffline = match.params.type === PATH.OFFLINE;
        const isEbon = match.params.type === PATH.EBON;

        let title = i18nPage.ONLINE_TITLE;
        if (isOffline) {
            title = i18nPage.OFFLINE_TITLE;
        } else if (isEbon) {
            title = i18nPage.EBON_TITLE;
        }

        return (
            <div>
                <HeadComponent title={title} description={i18nPage.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={match.url}>{title}</LocalizedBreadcrumbItem>
                <DirectoryPage
                    letter={match.params.letter || ''}
                    isCodePromo={isCodePromo}
                    isOffline={isOffline}
                    isEbon={isEbon}
                />
            </div>
        );
    }
}

MostPopularDirectoryPage.propTypes = {
    isCodePromo: PropTypes.bool,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        i18nPage: state.i18n.page.DIRECTORY.MOST_POPULAR
    };
};

const mapDispatchToProps = {
    clearFilter,
    sortPartnerOnOrder
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(MostPopularDirectoryPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/directory/MostPopularDirectoryPage.js